var multiplier = 0.8;
export var getSpacing = function () {
    var sizes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sizes[_i] = arguments[_i];
    }
    return sizes.map(function (size) { return (size * multiplier).toFixed(1) + "rem"; }).join(' ');
};
export var Spacing;
(function (Spacing) {
    Spacing["u0"] = "0";
    Spacing["u05"] = "0.4rem";
    Spacing["u1"] = "0.8rem";
    Spacing["u2"] = "1.6rem";
    Spacing["u3"] = "2.4rem";
    Spacing["u4"] = "3.2rem";
    Spacing["u5"] = "4rem";
    Spacing["u6"] = "4.8rem";
    Spacing["u7"] = "5.6rem";
    Spacing["u8"] = "6.4rem";
    Spacing["u9"] = "7.2rem";
    Spacing["u10"] = "8rem";
    Spacing["u11"] = "8.8rem";
    Spacing["u12"] = "9.6rem";
    Spacing["u13"] = "10.4rem";
    Spacing["u14"] = "11.2rem";
    Spacing["u15"] = "12rem";
    Spacing["u16"] = "12.8rem";
    Spacing["u17"] = "13.6rem";
    Spacing["u18"] = "14.4rem";
    Spacing["u19"] = "15.2rem";
    Spacing["u20"] = "16rem";
})(Spacing || (Spacing = {}));
